import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Students from "@/pages/Students";
import Batches from "@/pages/Batches";
import Attendance from "@/pages/Attendance";
import Leaves from "@/pages/Leaves";
import Materials from "@/pages/Materials";
import Announcements from "@/pages/Announcements";
import Placement from "@/pages/Placement";
import Profile from "@/pages/Profile";
import Reports from "@/pages/Reports";
import Certificates from "@/pages/Certificates";
import UserManagement from "@/pages/UserManagement";
import ForceChangePassword from "@/pages/ForceChangePassword";
import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/force-change-password" element={<ForceChangePassword />} />
          <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="students" element={<ProtectedRoute adminOnly><Students /></ProtectedRoute>} />
            <Route path="batches" element={<ProtectedRoute adminOnly><Batches /></ProtectedRoute>} />
            <Route path="attendance" element={<Attendance />} />
            <Route path="leaves" element={<Leaves />} />
            <Route path="materials" element={<Materials />} />
            <Route path="announcements" element={<Announcements />} />
            <Route path="placement" element={<Placement />} />
            <Route path="reports" element={<ProtectedRoute adminOnly><Reports /></ProtectedRoute>} />
            <Route path="user-management" element={<ProtectedRoute strictAdmin><UserManagement /></ProtectedRoute>} />
            <Route path="certificates" element={<Certificates />} />
            <Route path="profile" element={<Profile />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
